import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ProvisionsService } from '../services/provisions.service';
import { Provision } from '../models/provision.model';
import { BehaviorSubject } from 'rxjs';
import { Account } from '../models/account.model';
import { MatDialog } from '@angular/material/dialog';
import { CreateAzureAccountDialogComponent } from './create-azure-account-dialog/create-azure-account-dialog.component';
import { environment } from '../../environments/environment';
import { CoreService } from '../services/core.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomeComponent implements OnInit {
  accounts$ = new BehaviorSubject<Array<Account>>(new Array<Account>)
  accounts: Account[] = [];
  isAccountsLoading : boolean = false;
  env: string = environment.envName;
  cloudSelect = false;

  constructor(private _formBuilder: FormBuilder,
    private provisionsService: ProvisionsService, 
    private dialogRef: MatDialog, 
  ) {}
  
  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });

  ngOnInit(): void {
    this.isAccountsLoading = true
    this.provisionsService.getAccountsByCreator()
      .subscribe({
        
        next: (res:any) => {
          this.accounts$.next(res);
          this.accounts = res;
          // this.accounts[0].type = 1;
          this.isAccountsLoading = false;
        }, 
        error: (error) => {
          console.log("Error: unable to get all provisions");
          console.log(error);
        }
      });
  }
  cloudSelectToggle() {
    this.cloudSelect = !this.cloudSelect;
  }
  
  openCreateAzAcctDiag() {
    let dialogRef = this.dialogRef.open(CreateAzureAccountDialogComponent, {
      width: '570px', 
      maxHeight: '304px',
    })
  }
}
